export default {
  test: 'Test',
  tabel: {
    label: 'Chinese'
  },
  homePage:'home page',
  jadeFountainHill:'Jade Fountain Hill',
  guanLing:'GuanLing',
  recentNews:'recent news',
  playGuide:'Play guide',
  smartTourism:'Smart Tourism',
  forgame:'Forgame',
  oneClickReservation:'One click reservation',
  oneKeyNavigation:'One key navigation',
  messageInteraction:'Message interaction',
  yuquanCulturalTravel:'Yuquan Cultural Travel',
  companyProfile:'company profile',
  businessCooperation:'business cooperation',
  talentWanted:'Talent wanted',
  contactUs:'contact us',
  scenicSpotAddress:'Scenic spot address',
  businessHours:'business hours',
  Scenic_spot_dynamics:'Scenic spot dynamics',
  view_more:'view more',
  yysj_hint:'If there are special arrangements, the on-site opening shall prevail',
  yqsgljj:'Brief introduction of Yuquanshan Guanling',
  Click_for_details:'Click for details',
  playspot:'playspot',
  jqjj_text:'Yuquan Mountain Guanling Scenic Spot is invested and developed by Hubei Yuquan Culture Tourism Development Co., LTD., integrating the resources of Yuquan Mountain and Guanling, which were originally two independent scenic spots, with the Guangong culture as the core, through the form of one core and two wings, fully integrating the superior resources of the two scenic spots, and creating the Guangong culture as the core and the ecological landscape as the support. A comprehensive leisure tourism resort based on the thousand-year Yuquan culture.',
  syyq_text:'Poetic spring of jade',
  scgf_text:'Poetry',
  video:'video',
  audio:'audio',
  mtj_text:'tina and aom',
  ykxz_text:'Notice to Visitors',
  complaints_hotline:'complaints hotline',
  tiktok:'tiktok',
  red_bok:'red bok',
  official_account:'official account',
  micro_blog:'micro blog',
  gpfs_text:'Ticket purchase method',
  wwsb_text:'Three treasures of cultural relics',
  zwsb_text:'Three treasures of plants',
  sjbj_text:'Four wonders and eight views',
  unfold:'unfold',
  jqhd_text:'Scenic spot activity',
  jqgg_text:'Scenic spot announcement',
  back_text:'go back',
  view_details:'view details',
  fbpl_text:'add a comment',
  unit_text:'unit',
  phone_text:'phone',
  recruiter:'recruiter',
  wechat:'wechat',
  postbox:'email',
  jbyq_text:'basic requirements',
  xl_text:'education background',
  specialty:'specialty',
  zwms_text:'job description',
  fldy_text:'social benefits',
  yqs_dz:'The address of Yuquanshan',
  jdxq_text:'Scenic spot details',
  jqdt_text:'Scenic spot dynamics',
  jqhdxq_text:'Details of scenic spot activities',
  jqhdxq_title:'Event Details',
  close_text:'close',
}
// zh_cn与 en_us的key值需要保持一致



// WEBPACK FOOTER //
// ./src/lang/en.js